var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame209312(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint0_linear_1_49663)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.75C24.5552 9.75 25.0177 9.94089 25.4258 10.3486C25.8338 10.7568 26.0254 11.22 26.0254 11.7754V19.0654L26.3447 19.2891L38.25 27.6396V30.1885L27.0557 25.6797L26.0254 25.2637V32.8652L26.3447 33.0898L30.5996 36.0645V37.9893L24.2178 36.0576L24 35.9912L23.7832 36.0566L17.375 37.9902V36.0664L21.6533 33.0908L21.9746 32.8672V25.2637L20.9443 25.6797L9.75 30.1885V27.6396L21.6553 19.2891L21.9746 19.0654V11.7754C21.9746 11.22 22.1662 10.7568 22.5742 10.3486C22.9823 9.94089 23.4448 9.75 24 9.75Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_49663",
    x1: 0,
    y1: 24,
    x2: 48,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C25C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C18C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame209312);
export default __webpack_public_path__ + "static/media/Frame 2093 (12).96258c588382036cf3cac1b810fd675d.svg";
export { ForwardRef as ReactComponent };